import {
  ThemeProvider as MuiThemeProvider,
  type ThemeOptions,
  createTheme,
} from '@mui/material/styles';
import fontConfig from './fontConfig';
import getHighContrastModeThemeAdjustments from './getHighContrastModeThemeAdjustments';
import useActivePalette from './useActivePalette';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { type Palette, type PaletteOptions } from '@mui/material';
import { type Theme } from '@emotion/react';
import React from 'react';

type ThemeProviderProps = {
  children: React.ReactNode;
};

const buildTheme = (activePalette: PaletteOptions): Theme => {
  const theme = createTheme(
    {
      palette: activePalette,
      isDark: activePalette.mode === 'dark',
      transitions: {
        simple: 'all 300ms ease-in-out',
      },
      ...fontConfig,
    },
    getHighContrastModeThemeAdjustments(activePalette as unknown as Palette),
  );

  theme.extend = (themeExtensionObject: ThemeOptions) =>
    createTheme(theme as unknown as ThemeOptions, themeExtensionObject);

  return theme;
};

const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const activePalette = useActivePalette();
  const theme = buildTheme(activePalette);

  return (
    <MuiThemeProvider theme={theme}>
      <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
